/**
 * Validate and format time values for Active/Sleep time settings
 * @param {string} wake - Wake time in HH:MM:SS or HH:MM format
 * @param {string} sleep - Sleep time in HH:MM:SS or HH:MM format
 * @returns {object} Object with validated wake and sleep times { wake: 'HH:MM', sleep: 'HH:MM' }
 */
export const validateAndFormatTimes = (wake, sleep) => {
  // Convert HH:MM:SS format to HH:MM format by removing seconds
  const formatTime = (time) => time ? time.substring(0, 5) : null;

  const wakeTime = formatTime(wake);
  const sleepTime = formatTime(sleep);

  // If either time is missing, use defaults
  if (!wakeTime || !sleepTime) {
    return { wake: '00:00', sleep: '24:00' };
  }

  // Parse hours and minutes
  const [wakeHour, wakeMin] = wakeTime.split(':').map(Number);
  const [sleepHour, sleepMin] = sleepTime.split(':').map(Number);

  // Validate range (0:00 to 24:00)
  const isWakeValid = wakeHour >= 0 && wakeHour <= 24 && wakeMin >= 0 && wakeMin < 60 &&
    !(wakeHour === 24 && wakeMin > 0);
  const isSleepValid = sleepHour >= 0 && sleepHour <= 24 && sleepMin >= 0 && sleepMin < 60 &&
    !(sleepHour === 24 && sleepMin > 0);

  if (!isWakeValid || !isSleepValid) {
    return { wake: '00:00', sleep: '24:00' };
  }

  // Check if wake time < sleep time
  const wakeMinutes = wakeHour * 60 + wakeMin;
  const sleepMinutes = sleepHour * 60 + sleepMin;

  if (wakeMinutes > sleepMinutes) {
    return { wake: '00:00', sleep: '24:00' };
  }

  return { wake: wakeTime, sleep: sleepTime };
};

